import { IAppStatus, IAppProgress, ICategorys } from "@/common/interface";
import {
  statusClassName,
  statusText,
  monitorStText,
} from "@/common/softConfig";
import { SoftStatus } from "@q/softCore";
import classnames from "classnames";
import { isFunction } from "lodash-es";
import React, { MouseEvent, useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { IAds } from "@/common/interface";
import { sendClkLog } from "@/common/selfMonitor";
import { getDownloadHandler } from "@/utils/appInstall";
import {
  setDownLoadStore,
  getDownLoadStore,
  removeDownLoadStore,
} from "@/utils/com";

interface IProps {
  softId: number;
  name: string;
  ads?: IAds;
  className?: string;
  status?: SoftStatus;
  progress?: number;
  category?: "1" | "2" | "3";
  progressName?: string;
  onClick?: (status: number) => void;
  position?: string;
  comAds?: string[];
}

const validStatus = [
  SoftStatus.notDownloading,
  SoftStatus.downloadPaused,
  SoftStatus.downloadCanceled,
  SoftStatus.downloadFailed,
  SoftStatus.supportExpressInstall,
  SoftStatus.supportExpressUpdate,
  SoftStatus.supportPureInstall,
  SoftStatus.finishDownloadAndAboutToInstall,
  SoftStatus.installCanceled,
  SoftStatus.installFailed,
  SoftStatus.couldUpdate,
  SoftStatus.supportPureUpdate,
];

const DownloadBtn: React.FC<IProps> = (props: IProps) => {
  const {
    className = "",
    status = SoftStatus.notDownloading,
    softId,
    name,
    onClick,
    progress,
    ads,
    category,
    progressName,
    position = "",
  } = props;
  if (!softId) {
    return null;
  }
  const isUpgrade = className.indexOf("upgrade2") !== -1;
  let text = statusText[status];
  if (statusText[status] === "正在安装" && isUpgrade) {
    text = "正在升级";
  }

  const onClickHandler = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setDownLoadStore(`${softId}`, { isClick: true, position });
    // app.getDownloadHandler(status)(softId);
    // console.log(123)
    getDownloadHandler(status)(softId, position);
    const isValidStatus = validStatus.some((item) => item === status);
    if (isValidStatus && ads && ads.clktk) {
      ads.clktk.forEach((url) => {
        monitor.sendLog(url);
      });
    }
    if (isFunction(onClick)) {
      onClick(status);
    }
  };

  const mergeClassName = classnames(className, statusClassName[status]);
  // const progressStyle = { width: `${progress}%` };
  let progressStyle;
  if (isUpgrade) {
    progressStyle = {
      background: `linear-gradient(90deg, #FF8D1A, #FF8D1A ${progress}%, transparent 0)`,
    };
  } else {
    progressStyle = {
      background: `linear-gradient(90deg, #00CE68, #00CE68 ${progress}%, transparent 0)`,
    };
  }
  // const dataText = `${softId}-${name}-${text}`;
  const ct =
    category && category.length > 0
      ? `${ICategorys[category]}`
      : `${ICategorys[1]}`;

  const onMouseHandler = useCallback(
    (e: MouseEvent) => {
      // e.stopPropagation();
      // e.preventDefault();
      const text = monitorStText[status] || "";
      const params = {
        cId: position, //事件名称组名
        c: text, //事件名称
        from: ct,
        title: `${softId}-${name}`,
      };

      sendClkLog(params, "click");
      // setStartTime(Date.now());
    },

    [ct, name, position, softId, status],
  );

  useEffect(() => {
    if (progress == 100) {
      const downloadStore = getDownLoadStore(`${softId}`);
      if (downloadStore.isClick) {
        const params = {
          cId: downloadStore.position, //事件名称组名
          c: "下载完成", //事件名称
          from: ct,
          title: `${softId}-${name}`,
        };

        sendClkLog(params, "click");
        removeDownLoadStore(`${softId}`);
      }
    }
  }, [ct, name, progress, softId]);

  return (
    <a
      href="javascript: void(0)"
      className={mergeClassName}
      onClick={onClickHandler}
      onMouseDown={onMouseHandler}
    >
      <span className="soft-btn__text">{text}</span>
      {progress ? (
        <span
          className={classnames("soft-btn__progress", progressName)}
          style={progressStyle}
        />
      ) : null}
    </a>
  );
};

const mapStateToProps = (
  { appStatus = {} as IAppStatus, appProgress = {} as IAppProgress },
  { softId }: IProps,
) => ({
  status: appStatus[softId],
  progress: (appProgress[softId] && appProgress[softId].progress) || 0,
});

export default connect(mapStateToProps)(DownloadBtn);
